/**
 * Flexible y Commit puro no aplican % de licencia en el cálculo.
 * El % cotizado debe quedarse en el documento: al volver a un plazo en meses reaparece.
 */

export const mergePreservedDiscount = (storedLic, fromProposalLic) => {
  const stored = storedLic?.descuento;
  const from = fromProposalLic?.descuento;
  if (from != null && Number(from) > 0) return from;
  if (stored != null && stored !== '') return stored;
  return from ?? 0;
};

/** True si alguna SKU baja de un % guardado a uno menor (p. ej. 30 → 0). */
export const licenseDiscountsDropped = (previous = [], next = []) => {
  const nextBySku = new Map((next || []).map((l) => [l.sku, l]));
  return (previous || []).some((prev) => {
    const nxt = nextBySku.get(prev.sku);
    if (!nxt) return false;
    return (Number(prev.descuento) || 0) > (Number(nxt.descuento) || 0);
  });
};
